import { Button, Flex } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";
const { Outlet } = require("react-router-dom")

const TransactionComponent = ({
    stepTransaction = () => { },
    transactionFooter = () => { }
}) => {
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const { goToMenu = () => { } } = useWepapp()
    return (
        <Flex vertical style={{ backgroundColor: "#FCF9F6", height: isPortrait ? "100vh" : "80vw" }}>
            {/* <Button onClick={() => goToMenu("verify")}>Time to verify code</Button> */}
            <Flex vertical style={{ padding: "4vh", flexGrow: 1 }}>
                {stepTransaction()}
            </Flex>
            {transactionFooter()}
        </Flex>
    )
}
export default TransactionComponent;